// Grid > IGrid
export const gridDefaultProps: Partial<GridContainerProps> = Object.freeze({
	inline: false,
	container: true,
	columnGap: 'auto',
	rowGap: 'auto',
	justifyItems: 'center',
	alignItems: 'center'
})

export type GridProps = {
	container: boolean
	className?: string
}

export type GridContainerProps = {
	inline: boolean
	columns: string
	rows: string
	columnGap: string | number
	rowGap: string | number
	justifyItems?: 'start' | 'end' | 'center' | 'stretch'
	alignItems?: 'start' | 'end' | 'center' | 'stretch'
	justifyContent?: 'start' | 'end' | 'center' | 'stretch' | 'space-around' | 'space-between' | 'space-evenly'
	alignContent?: 'start' | 'end' | 'center' | 'stretch' | 'space-around' | 'space-between' | 'space-evenly'
}

export type GridItemProps = {
	columnStart: number | string
	columnEnd: number | string
	rowStart: number | string
	rowEnd: number | string
	justifySelf?: 'start' | 'end' | 'center' | 'stretch'
	alignSelf?: 'start' | 'end' | 'center' | 'stretch'
}
